import { useEffect, useRef, useState } from 'react';
import useShowSnackbar from 'hooks/useShowSnackbar';
import useLookupPage from './useLookupPage';
import { resolveLicensingReferences } from '../components/licensingReferences';

const useLicensingPage = (entity, columns) => {
    const page = useLookupPage(entity, columns);
    const rows = page.rows;
    const [result, setResult] = useState({ source: null, rows: [], failed: false });
    const showSnackbar = useShowSnackbar();
    const notified = useRef(null);
    useEffect(() => {
        const controller = new AbortController();
        let current = true;
        resolveLicensingReferences(rows, controller.signal).then(data => {
            if (current) setResult({ ...data, source: rows });
        });
        return () => { current = false; controller.abort(); };
    }, [rows]);
    useEffect(() => {
        if (result.source === rows && result.failed && notified.current !== rows) {
            notified.current = rows;
            showSnackbar('Some lookup names could not be loaded. Refresh the list to try again.', 'error');
        }
    }, [result, rows, showSnackbar]);
    return { ...page, rows: result.source === rows ? result.rows : rows, loading: page.loading || (rows.length > 0 && result.source !== rows) };
};
export default useLicensingPage;
